import React from 'react';
import { Route } from 'react-router-dom';
import ModulesRouter from './Modules/Modules.router';
import UsersRouter from './Users/Users.router';
import ConfiguracionRouter from './Configuracion/Configuracion.router';
import OtpRouter from './Otp/Otp.router';
import WhatsAppRouter from './whatsapp/WhatsApp.router';
import OrdePagoRouter from './OrdenPago/OrdenPago.router';
import NotificacionesRouter from './Notificaciones/Notificaciones.router';

const AdminisrtracionComponent = React.lazy(() => import('./Administracion'));
const AdministracionRouter = (
  <Route path="admin" element={<AdminisrtracionComponent />}>
    {ModulesRouter}
    {UsersRouter}
    {ConfiguracionRouter}
    {OtpRouter}
    {WhatsAppRouter}
    {OrdePagoRouter}
    {NotificacionesRouter}
  </Route>
);

export default AdministracionRouter;
